const initialState = () => ({
  cdTableOptions: {
    page: 1,
    itemsPerPage: 25,
    totalItems: 0,
    sortBy: [],
    sortDesc: [],
  },
  coTableOptions: {
    page: 1,
    itemsPerPage: 25,
    totalItems: 0,
    sortBy: [],
    sortDesc: [],
  },
  customerData: {},
  smartThermostatList: [],
  memberAddress: {},
  activeTab: 'overview',
  actionModalView: '',
  showActionModal: false,
  customer: {},
  providerPlan: {},
  propertyProfiles: [],
  propertyProfile: {},
  subscription: [],
  cancelSubscriptionList: [],
  cancellingSubscription: false,
  requestingNameplate: false,
  gettingNameplateLogs: false,
  latestNameplateLog: {},
  hubs: [],
  hvac: [],
  tZones: [],
  customerOrders: [],
  loadingOrders: false,
  coTableSearch: '',
  imageFormData: new FormData(),
  uploadImageType: 'nameplate',
  uploadingImage: false,
  loadingCommonFilters: false,
  currentHvac: {},
  currentFilter: {},
  currentSensor: {},
  currentHub: {},
  commonFilters: [],
  thicknessList: [],
  filteredHvac: [],
  systemNames: [],
  sensors: [],
  filters: [],
  allAlerts: [],
  alertTableData: [],
  activityTableData: [],
  activityTableSearch: '',
  allCycles: [],
  rangedCycles: [],
  cycleTableData: [],
  deltaTTableData: [],
  alertFilter: {
    reason: '',
    zone: '',
    deltaT: '',
    outside: '',
    supRet: '',
    cLength: '',
    status: 'all',
    range: {
      start: null,
      end: null,
    },
  },
  alertSort: {
    reason: false,
    zone: false,
    deltaT: false,
    outside: false,
    supRet: false,
    cLength: false,
    status: false,
  },
  systemFilterRef: {
    thermostatZone: [],
    singleTZone: '',
    cycleTypeFilter: [],
    deltaTFilter: [],
    dateFilter: 'past7',
    alertCategoryFilter: [],
    dateRange: {
      start: '',
      end: '',
    },
    allTZoneSelected: true,
  },
  systemFilter: {
    thermostatZone: [],
    singleTZone: '',
    cycleTypeFilter: [],
    deltaTFilter: [],
    dateFilter: 'past7',
    alertCategoryFilter: [],
    dateRange: {
      start: '',
      end: '',
    },
    allTZoneSelected: true,
  },
  cycleFilter: {
    type: 'cool',
    location: '',
    status: false,
    qualifying: false,
    date: '3',
    range: {
      start: null,
      end: null,
    },
    deltaT: {
      five: false,
      ten: false,
      fifteen: false,
      twenty: false,
      twentyFive: false,
      thirty: false,
    },
  },
  cycleViewTab: 'table',
  cycleDetail: {},
  showCycleDetailModal: false,
  cycleSort: {},
  infoEditing: false,
  billingEditing: false,
  shippingEditing: false,
  showInfoEdit: false,
  showBillingEdit: false,
  showShippingEdit: false,
  newCustomerInfo: {},
  newHVACInfo: {},
  newServiceAddress: {},
  newBillingAddress: {},
  newShippingAddress: {},
  selectedData: [],
  selectedSystemName: '',
  runtimeGraphData: [],
  initialRuntimeGraphData: [],
  allRuntimeData: [],
  timescaleDays: 7,
  alertsTabTableData: [],
  alertTabFilter: {
    zone: 'All',
    category: 'All',
  },
  alertTabCategories: [],
  customerAllAlerts: {
    active: [],
    history: [],
  },
  alertShowType: 'active',
  loadingRuntimeGraph: true,
  loadingAlertsTab: true,
  loading: false,
  getCustomerAlertLoading: false,
  alertLoading: true,
  activityLoading: false,
  cycleLoading: true,
  generatingCSV: false,
  showWrongDateRangePopup: false,
  csvGenerated: 0,
  errorObj: {},
  exportCSV: {
    range: {
      start: null,
      end: null,
    },
    uid: '',
  },
  chronicAlerts: [],
  supplySensors: [],
  supplySerials: [],
  systemFilterOptions: [],
  mergeCustomers: [],
  selectedMergeCustomer: {},
  mergeForm: [],
  // Processing State
  sendingEmail: false,
  loadingMergeCustomers: false,
  mergingMember: false,
  pressureConversion: 248.84,
  selectedSerial: '',
  allCorpPlans: [],
  allCorpPlansWithArchived: [],
  reasons: '',
  virtualVisits: [],
  filterBrands: [],
  selectedVirtualVisit: {},
  selectedTechnician: {},
  technicianAvatar: '',
  recordingInProgress: false,
  visualizeUid: null,
  filterOptions: [{
    label: 'Merv 8: Standard | Allergies',
    value: 8,
  }, {
    label: 'Merv 11: Plus | Allergies, Pet Dander',
    value: 11,
  }, {
    label: 'Merv 13: Premium | Allergies, Pet Dander, Virus Carriers',
    value: 13,
  }],
  ventOptions: [{
    label: 'Wall',
    value: 'Wall',
  }, {
    label: 'Ceiling',
    value: 'Ceiling',
  }, {
    label: 'Furnace/Air Handler',
    value: 'Furnace/Air Handler',
  }],

  // Performance Summary props
  selectedUnit: '',
  dailyStats: [],
  recentCycleList: [],
  waterLeakAlertList: [],
  rawPayloads: {},
  comfortCreditBalance: 0,
  loadingSummary: false,
  loadingComfortCredit: false,
  loadingCycleList: false,
  loadingWaterLeakList: false,
  loadingRawPayload: false,
  customerPartnerSettings: {},
  performanceScores: {},
  loadingPerformanceScores: false,
});

export default initialState;
